import { useEffect, useState } from 'preact/hooks'
import useBundleGlobal from 'hooks/useBundleGlobal'
import useProductForm from 'hooks/useProductForm'
import useDetectBreakpoint from 'hooks/useDetectBreakpoint'
import clsx from 'clsx'
import throttle from 'lodash.throttle'
import { inViewPort } from 'helpers/utils'
import { on, off, select } from 'helpers/dom'
import { globalEmitter, emitterProps } from 'helpers/emitter-event'
import ProductATC from 'snippets/product/product-atc/product-atc'
import Price from 'snippets/price/price'
import ButtonBIS from 'snippets/button-atc/button-bis'

const selectors = {
  PRODUCT_FORM_SELECTOR: '.js-product-form'
}

function ProductFormSticky() {
  const { currentVariant, initProduct, updateCurrentVariant } = useProductForm()
  const { productBundles } = useBundleGlobal()
  const { available } = currentVariant
  const { title, type, compareAtPrice, tags } = initProduct
  const [isActive, setIsActive] = useState(false)
  const { isMobile } = useDetectBreakpoint()
  const productForm = select(selectors.PRODUCT_FORM_SELECTOR)
  const hasNoNotifyMeTag = (tags.length > 0 && tags.some((tag) => tag === 'no-notify-me')) || false
  const enableBackInStock = !available && !hasNoNotifyMeTag

  const [currentVariantPrice, setCurrentVariantPrice] = useState(currentVariant.price)
  const [sellingPlanId, setSellingPlanId] = useState(null)

  if (!isMobile) return null

  useEffect(() => {
    const handleScroll = throttle(() => {
      if (window.scrollY === 0) {
        inViewPort(productForm, () => {
          setIsActive(false)
        })
      } else {
        setIsActive(false)
      }
    }, 100)

    const handlePriceUpdate = (newPrice) => {
      setCurrentVariantPrice(newPrice)
    }

    const handleSellingPlanUpdate = (newSellingPlanId) => {
      setSellingPlanId(newSellingPlanId)
    }

    handleScroll()
    on('scroll', handleScroll, window)

    globalEmitter.on(emitterProps.product.updatePrice, handlePriceUpdate)
    globalEmitter.on(emitterProps.product.updateSellingPlan, handleSellingPlanUpdate)

    return () => {
      off('scroll', handleScroll, window)
      globalEmitter.off(emitterProps.product.updatePrice, handlePriceUpdate)
      globalEmitter.off(emitterProps.product.updateSellingPlan, handleSellingPlanUpdate)
    }
  }, [])

  useEffect(() => {
    setCurrentVariantPrice(currentVariant.price)
    setSellingPlanId(null)
  }, [currentVariant])

  return (
    <div
      className={clsx(
        'fixed bottom-0 left-0 right-0 z-40 border-t border-neutral-200 bg-white p-5 transition-all duration-500',
        isActive ? 'visible translate-y-0 opacity-100' : 'pointer-events-none invisible translate-y-full opacity-0'
      )}
    >
      <div className="flex justify-between gap-4">
        <div className="flex flex-col gap-1">
          <h2 className="text-sm font-normal uppercase text-neutral-900">{title}</h2>
          {type && <span className="text-xs-medium text-neutral-700 lg:text-xs">{type}</span>}
        </div>
        <Price
          price={currentVariantPrice}
          originalPrice={compareAtPrice}
          classSalePrice="text-sm font-normal"
          className="plp-card-price flex justify-end gap-2 text-sm text-neutral-900"
        />
      </div>
      <div class="mt-4 flex w-full">
        {enableBackInStock ? (
          <ButtonBIS
            product={initProduct}
            currentVariant={currentVariant}
            buttonText={translate.product.notifyMeWhenAvailable}
            classButton="button-primary relative w-full uppercase !rounded-r-none"
          />
        ) : (
          <ProductATC
            title={title}
            productBundles={productBundles}
            buttonText={translate.general.addToCart}
            currentVariant={currentVariant}
            isEnabledInput={false}
            buttonClass="button button-primary flex-1 !rounded-r-none !mt-0"
            classWrap="flex-1"
            updateCurrentVariant={updateCurrentVariant}
            currentVariantPrice={currentVariantPrice}
            sellingPlanId={sellingPlanId}
            initProduct={initProduct}
          />
        )}
      </div>
    </div>
  )
}

export default ProductFormSticky
